const C = require("../constants");

const openModalIngredientStock = data => {
    return {
        type: C.INGREDIENTS_STOCK_MODAL,
        data
    }
};

export {openModalIngredientStock};


// WEBPACK FOOTER //
// ./src/actions/ModalIngredientStockActions.js